<template>
  <div style="height: 0px; overflow: hidden">
    <div
      id="lodopPrintForNoDataPackage"
      class="print-content"
      style="width: 284px; height: 189px; overflow: hidden"
    >
      <div
        style="
          font-size: 18px;
          width: 268px;
          text-align: center;
          word-break: break-all;
          font-weight: bold;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        "
      >
        {{ contents.supply_name }}
      </div>
      <el-row style="display: flex; align-items: center" :gutter="8">
        <el-col :span="8" style="text-align: center">
          <div style="padding: 4px 0">
            <qrcode-vue
              :value="contents.no_data_package_no"
              :size="80"
              level="H"
              render-as="svg"
            />
          </div>
        </el-col>
        <el-col :span="16" style="text-align: center; margin-bottom: 2px">
          <div
            style="
              margin-bottom: 5px;
              line-height: 1;
              font-size: 16px;
              font-weight: bold;
              word-break: break-all;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            "
          >
            {{ contents.no_data_package_no }}
          </div>
          <div
            style="
              margin-bottom: 5px;
              line-height: 1;
              font-size: 16px;
              font-weight: bold;
              word-break: break-all;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            "
          >
            件数：{{ contents.tool_num
            }}<span style="margin-left: 12px">{{ contents.pgname }}</span>
          </div>
          <div
            style="
              margin-top: 2px;
              font-size: 16px;
              line-height: 1.1;
              font-weight: bold;
              word-break: break-all;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            "
          >
            退还方式：{{ contents.return_packet_return_mode_type }}
          </div>
        </el-col>
      </el-row>
      <div
        style="
          font-size: 14px;
          width: 268px;
          text-align: center;
          word-break: break-all;
          font-weight: bold;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        "
      >
        地址：{{ contents.return_exchange_receive_address }}
      </div>
    </div>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import getLodop from "@/assets/js/LodopFuncs.js";

export default {
  components: {
    QrcodeVue,
  },
  data() {
    return {
      contents: {
        qr_code: "",
        pgname: "",
        no_data_package_no: "",
        supply_name: "",
        tool_num: "",
      },
    };
  },
  methods: {
    calling(contents) {
      this.contents = contents;
      // 请求完成校验接口
      setTimeout(() => {
        this.print("lodopPrintForNoDataPackage", "-1");
      }, 100);
    },
    print(id, PRINTER_INDEX) {
      const ele = document.getElementById(id);
      const html = ele.innerHTML;
      let h = ele.offsetHeight;
      h = `${h / 3.78}mm`;
      let w = ele.offsetWidth;
      w = `${w / 3.78}mm`;
      const LODOP = getLodop(); // 调用getLodop获取LODOP对象
      LODOP.PRINT_INIT("");
      // 添加license
      LODOP.SET_LICENSES(
        "广州富米科技有限公司",
        "A564177D3271E3CFF371162E393C53F6AE2",
        "廣州富米科技有限公司",
        "750CF994CE8CD4FE765C2B772159BF47828"
      );
      LODOP.SET_LICENSES(
        "THIRD LICENSE",
        "",
        "Guangzhou Fumi Technology Co., Ltd.",
        "CA02B8F057FF195E4C65561D1AD6492A379"
      );
      // 设置打印机 -1为默认
      const re = LODOP.SET_PRINTER_INDEX(PRINTER_INDEX);

      if (re) {
        LODOP.ADD_PRINT_HTM("3mm", "3mm", w, h, html);
        LODOP.PRINT();
        // LODOP.PREVIEW();
      } else {
        this.$message.error("打印机设置失败;请检查是否设置默认打印机");
      }
    },
  },
};
</script>

<style lang="css" scoped>
.print-content {
  width: 80%;
  box-sizing: border-box;
  padding: 4px;
}
</style>



// WEBPACK FOOTER //
// src/pages/nodatagoods/components/lodopPrintForNoDataPackage.vue